import http from '@/http';

export default {
  namespaced: true,
  actions: {
    async getSetting() {
      const response = await http.get('printer/setting');

      return response;
    },
  },
};
